"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _classnames4 = _interopRequireDefault(require("classnames"));

var _events = _interopRequireDefault(require("../utils/events"));

var _mask = _interopRequireDefault(require("../mask"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var IS_REACT_16 = !!_reactDom.default.createPortal;

var Portal = /*#__PURE__*/function (_PureComponent) {
  _inherits(Portal, _PureComponent);

  var _super = _createSuper(Portal);

  function Portal(props) {
    var _this;

    _classCallCheck(this, Portal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "enterTimer", void 0);

    _defineProperty(_assertThisInitialized(_this), "popup", void 0);

    _defineProperty(_assertThisInitialized(_this), "_container", void 0);

    _defineProperty(_assertThisInitialized(_this), "animationEnd", function (e) {
      e.stopPropagation();
      var _this$props = _this.props,
          afterClose = _this$props.afterClose,
          afterOpen = _this$props.afterOpen,
          handlePortalUnmount = _this$props.handlePortalUnmount;
      var animationState = _this.state.animationState;

      if (animationState === 'leave') {
        _this.setState({
          isShow: false,
          isPending: false
        });

        if (typeof afterClose === 'function') {
          afterClose();
        }

        if (typeof handlePortalUnmount === 'function') {
          handlePortalUnmount();
        }
      } else if (typeof afterOpen === 'function') {
        afterOpen();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderMask", function () {
      var _this$props2 = _this.props,
          mask = _this$props2.mask,
          maskType = _this$props2.maskType,
          animationDuration = _this$props2.animationDuration;
      var _this$state = _this.state,
          animationState = _this$state.animationState,
          isShow = _this$state.isShow;
      var maskCls = (0, _classnames4.default)(_defineProperty({}, "za-fade-".concat(animationState), isShow));
      var maskStyle = {
        WebkitAnimationDuration: "".concat(animationDuration, "ms"),
        animationDuration: "".concat(animationDuration, "ms")
      };
      return mask && /*#__PURE__*/_react.default.createElement(_mask.default, {
        className: maskCls,
        style: maskStyle,
        visible: isShow,
        type: maskType,
        onClick: function onClick(e) {
          _this.handleMaskClick(e);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "createContainer", function () {
      if (!_this._container) {
        _this._container = document.createElement('div');
        _this._container.className += 'popup-container';
        document.body.appendChild(_this._container);
      }

      return _this._container;
    });

    _defineProperty(_assertThisInitialized(_this), "getComponent", function () {
      var _classnames3;

      var _this$props3 = _this.props,
          prefixCls = _this$props3.prefixCls,
          className = _this$props3.className,
          animationType = _this$props3.animationType,
          animationDuration = _this$props3.animationDuration,
          direction = _this$props3.direction,
          mask = _this$props3.mask,
          children = _this$props3.children,
          width = _this$props3.width;
      var _this$state2 = _this.state,
          isShow = _this$state2.isShow,
          animationState = _this$state2.animationState,
          isPending = _this$state2.isPending;
      var cls = {
        wrapper: (0, _classnames4.default)("".concat(prefixCls, "__wrapper"), className, _defineProperty({}, "za-fade-".concat(animationState), direction === 'center' && isPending)),
        popup: (0, _classnames4.default)(prefixCls, (_classnames3 = {}, _defineProperty(_classnames3, "".concat(prefixCls, "--").concat(direction), !!direction), _defineProperty(_classnames3, "".concat(prefixCls, "--nomask"), direction === 'center' && !mask), _defineProperty(_classnames3, "".concat(prefixCls, "--hidden"), animationState === 'leave'), _defineProperty(_classnames3, "za-".concat(animationType, "-").concat(animationState), direction === 'center' && isPending), _classnames3))
      };
      var wrapStyle = direction === 'center' ? {
        WebkitAnimationDuration: "".concat(animationDuration, "ms"),
        animationDuration: "".concat(animationDuration, "ms")
      } : {};
      var popupStyle = direction === 'center' ? {
        width: width,
        WebkitAnimationDuration: "".concat(animationDuration, "ms"),
        animationDuration: "".concat(animationDuration, "ms")
      } : {
        WebkitTransitionDuration: "".concat(animationDuration, "ms"),
        transitionDuration: "".concat(animationDuration, "ms")
      };

      if (direction === 'center' && !isShow) {
        popupStyle.display = 'none';
      }

      if (!mask) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: cls.popup,
          style: popupStyle,
          role: "dialog",
          ref: function ref(popup) {
            _this.popup = popup;
          }
        }, children);
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        role: "dialog",
        className: cls.wrapper,
        style: wrapStyle,
        ref: function ref(popup) {
          _this.popup = popup;
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: cls.popup,
        style: popupStyle,
        role: "document"
      }, children), _this.renderMask());
    });

    _defineProperty(_assertThisInitialized(_this), "handleMaskClick", function (e) {
      e.stopPropagation();
      var onMaskClick = _this.props.onMaskClick;

      if (typeof onMaskClick === 'function') {
        onMaskClick();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderPortal", function () {
      if (!IS_REACT_16) {
        _reactDom.default.unstable_renderSubtreeIntoContainer(_assertThisInitialized(_this), _this.getComponent(), _this._container);

        return null;
      }

      return /*#__PURE__*/_reactDom.default.createPortal(_this.getComponent(), _this._container);
    });

    _this.state = {
      isShow: false,
      isPending: false,
      animationState: 'leave',
      mounted: false
    };
    return _this;
  }

  _createClass(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var visible = this.props.visible;

      if (visible) {
        this.showPortal();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var visible = this.props.visible;

      if (nextProps.visible !== visible) {
        nextProps.visible === true ? this.showPortal() : this.leave();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.popup) {
        _events.default.off(this.popup, 'webkitTransitionEnd', this.animationEnd);

        _events.default.off(this.popup, 'transitionend', this.animationEnd);

        _events.default.off(this.popup, 'webkitAnimationEnd', this.animationEnd);

        _events.default.off(this.popup, 'animationend', this.animationEnd);
      }

      clearTimeout(this.enterTimer);

      if (this._container) {
        document.body.removeChild(this._container);
      }
    }
  }, {
    key: "showPortal",
    value: function showPortal() {
      var _this2 = this;

      this.createContainer();
      this.setState({
        mounted: true
      }, function () {
        _events.default.on(_this2.popup, 'webkitTransitionEnd', _this2.animationEnd);

        _events.default.on(_this2.popup, 'transitionend', _this2.animationEnd);

        _events.default.on(_this2.popup, 'webkitAnimationEnd', _this2.animationEnd);

        _events.default.on(_this2.popup, 'animationend', _this2.animationEnd);

        _this2.enterTimer = setTimeout(function () {
          _this2.enter();
        }, 0);
      });
    }
  }, {
    key: "enter",
    value: function enter() {
      this.setState({
        isShow: true,
        isPending: true,
        animationState: 'enter'
      });
    }
  }, {
    key: "leave",
    value: function leave() {
      this.setState({
        isShow: true,
        isPending: true,
        animationState: 'leave'
      });
    }
  }, {
    key: "render",
    value: function render() {
      var mounted = this.state.mounted;

      if (!mounted) {
        return null;
      }

      return this.renderPortal();
    }
  }]);

  return Portal;
}(_react.PureComponent);

exports.default = Portal;

_defineProperty(Portal, "defaultProps", {
  prefixCls: 'cre-popup',
  visible: false,
  mask: true,
  direction: 'bottom',
  animationType: 'fade',
  animationDuration: 200,
  handlePortalUnmount: undefined
});